import { InjectionToken } from '@angular/core';
import { StateStorageLocation } from '../models/state-storage-location';

export interface StateConfig {
    stateStorageLocation: StateStorageLocation;
}

export const STATE_CONFIG: InjectionToken<StateConfig> = new InjectionToken<StateConfig>('state-config');
